import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", {
  role: "button",
  class: "fl mt5 mr20 mr4",
  style: {}
}, "複製", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_5 = ["src"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", {
  role: "button",
  class: "fl mt5 mr20 mr4",
  style: {}
}, "編集", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_8 = ["src"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", {
  role: "button",
  class: "fl mt5 mr20 alertRed",
  style: {}
}, "削除", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")!

  return (_openBlock(), _createBlock(_component_Dropdown, {
    ref: "dropdown",
    id: "roomEditMenu",
    style: {"min-width":"100px"}
  }, {
    dropdown: _withCtx(() => [
      (_ctx.aform.is_owner_group && _ctx.aform.status != -10)
        ? (_openBlock(), _createElementBlock("li", {
            key: 0,
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.copyPage && _ctx.copyPage(...args))),
            class: "fs12 pointer fw600 pad5",
            style: {"line-height":"40px","width":"160px"}
          }, [
            _createElementVNode("img", {
              src: _ctx.$getAssetImageUrl(`/assets/icons/copy_icon.png`),
              width: "17",
              height: "17",
              class: "ml14 fl mt4 mr20",
              style: {}
            }, null, 8, _hoisted_2),
            _hoisted_3,
            _hoisted_4
          ]))
        : _createCommentVNode("", true),
      (_ctx.showEditColumn)
        ? (_openBlock(), _createElementBlock("li", {
            key: 1,
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.editPage && _ctx.editPage(...args))),
            class: "fs12 pointer fw600 pad5",
            style: {"line-height":"40px","width":"160px"}
          }, [
            _createElementVNode("img", {
              src: _ctx.$getAssetImageUrl(`/assets/icons/editPen.png`),
              width: "17",
              height: "17",
              class: "ml15 fl mt4 mr20",
              style: {}
            }, null, 8, _hoisted_5),
            _hoisted_6,
            _hoisted_7
          ]))
        : _createCommentVNode("", true),
      (_ctx.aform.is_owner_group && _ctx.canDelete)
        ? (_openBlock(), _createElementBlock("li", {
            key: 2,
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.showCloseRoomModal && _ctx.showCloseRoomModal(...args))),
            class: "fs12 pointer fw600 pad5",
            style: {"line-height":"40px","width":"160px"}
          }, [
            _createElementVNode("img", {
              src: _ctx.$getAssetImageUrl(`/assets/icons/status_ng.png`),
              width: "17",
              height: "17",
              class: "ml17 fl mt6 mr20",
              style: {}
            }, null, 8, _hoisted_8),
            _hoisted_9,
            _hoisted_10
          ]))
        : _createCommentVNode("", true)
    ]),
    default: _withCtx(() => [
      _createElementVNode("button", {
        class: "dropdown-toggle fw600 fr centered fs12",
        style: {"width":"35px","margin-right":"5%","margin-top":"-3px","background-color":"transparent","border":"none","appearance":"none","padding":"0","outline":"none"},
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clickEditMenu && _ctx.clickEditMenu(...args)))
      }, [
        _createElementVNode("img", {
          src: _ctx.$getAssetImageUrl(`/assets/icons/line3.png`),
          width: "30",
          height: "30",
          class: "fr pointer"
        }, null, 8, _hoisted_1)
      ])
    ]),
    _: 1
  }, 512))
}